import { FC } from 'react';
// import { useMyTranslations } from 'hooks/useMyTranslations';
// import { appLoaderTranslations } from './translations';
// import { AppLoaderTransFields } from './types';
// import styles from './appLoader.module.scss';

export const NotFound: FC = () => {
  // const { t } = useMyTranslations<AppLoaderTransFields>([appLoaderTranslations.name]);

  return <>Not Found</>;
};
